import React, { useContext, useState } from 'react';
import MainChildHeader from '../Dashboard/Main/MainChildHeader';
import {
  VStack,
  Button,
  Text,
  Image,
  WrapItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Heading,
  Flex,
  Stack,
  Box,
  useDisclosure,
  Icon,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { AccountContext } from '../AccountContext';
import BottomNavBar from '../BottomNavBar';
import { ReactComponent as ChevronRight } from '../../images/chevron-right.svg';

import png6 from '../../images/assets/icons/Component-6.png';
import ModalSuporte from './ModalSuporte';
import { FcOnlineSupport } from 'react-icons/fc';
import suporteTecnico from '../../images/assets/icons/suporte-tecnico.png';
import { BiSupport } from 'react-icons/bi';
import { getAppTheme, userIsSubscriber } from '../Utils/theme';

import { IconList } from '../Perfil/Pagamento/Icons/MenuPerfil';
import { api } from 'api/api';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function ListItem({ text, description, leftIcon, onClick }) {
  const { user } = useContext(AccountContext);
  const theme = getAppTheme(userIsSubscriber(user));
  const IconComponent = leftIcon && IconList[leftIcon];

  return (
    <Flex
      width={'100%'}
      justifyContent={'space-between'}
      alignItems={'center'}
      gap={4}
      onClick={onClick}
      pt={2}
      pb={4}
      borderBottom={'2px solid #EBEBEB'}
    >
      {IconComponent ? <IconComponent color={theme.background} /> : <BiSupport color={theme.background} />}
      <Box flex={1}>
        <Text color={'#585858'}>{text}</Text>
        <Text fontSize={'xs'} color={'#9A9A9A'}>
          {description}
        </Text>
      </Box>
      <ChevronRight style={{ color: '#585858' }} />
    </Flex>
  );
}

function Main() {
  const navigate = useNavigate();
  const [sair, setSair] = useState(false);
  const { setPage, setUser, user } = useContext(AccountContext);

  //console.log("subscriberTheme, defaultTheme ", theme)
  setPage('Perfil');
  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('token');
      await api(`${ENDPOINT}/auth/logout/${user.username}/${token}`, {
        method: 'GET',
        credentials: 'include',
      });
      const postMessageReactNative = {
        event: 'logout',
      };
      localStorage.removeItem('token');
      window?.ReactNativeWebView?.postMessage(JSON.stringify(postMessageReactNative));
    } catch (error) {
      console.error(error.message);
    }
  };
  const disclousureSuporte = useDisclosure();
  const theme = getAppTheme(userIsSubscriber(user));
  return (
    <>
      <ModalSuporte disclosure={disclousureSuporte} />
      <Modal isOpen={sair} isCentered>
        <ModalOverlay />
        <ModalContent height="250px" width="300px" border-radius="16px">
          <ModalHeader></ModalHeader>

          <ModalBody>
            <Image ml="110" src={png6} size="lg"></Image>
            <Heading size="md" ml="3" mt="15">
              Deseja realmente sair do sistema?
            </Heading>
            <VStack></VStack>
          </ModalBody>

          <VStack ml="4">
            <ModalFooter></ModalFooter>

            <ModalFooter>
              <Stack direction="row" ml="-4" mt="-5" spacing={5} align="center">
                <Button
                  colorScheme="teal"
                  color="#5AB2AE"
                  variant="outline"
                  size="lg"
                  onClick={() => {
                    sessionStorage.removeItem('dashboardValoresTelemedicina');
                    sessionStorage.removeItem('dashboardValoresPresenciais');
                    setUser((prevState) => ({ loggedIn: false, build: prevState.build ? prevState.build : null }));
                    handleLogout();
                    navigate('/dashboard');
                  }}
                >
                  Sim
                </Button>
                <Button
                  backgroundColor={user.id_contrato ? '#5AB2AE' : '#5AB2AE'}
                  color="#FFF"
                  variant="solid"
                  size="lg"
                  onClick={() => {
                    setSair(false);
                  }}
                >
                  Não
                </Button>
              </Stack>
            </ModalFooter>
          </VStack>
        </ModalContent>
      </Modal>
      <MainChildHeader />
      <VStack p={8}>
        {/*{user.titular === true && user.id_contrato > 0 && (
          <Flex>
            <Text colorScheme="teal" variant="outline" fontWeight="bold" onClick={() => navigate('/perfil/dependentes')}>
              Adicionar/editar dependentes
              <Image boxSize="28px" objectFit="cover" src={png7} alt="" ml="260" mt="-7" />
              <Image boxSize="40px" objectFit="cover" src={png2} alt="" ml="-14" mt="-8" />
            </Text>
          </Flex>
        )} */}
        <ListItem
          text={'Dados Pessoais'}
          description={'Informações da minha conta'}
          leftIcon="DadosPessoais"
          onClick={() => navigate('/perfil/dados-pessoais')}
        ></ListItem>

        <ListItem text={'Endereço'} description={'Meu endereço'} leftIcon={'Endereco'} onClick={() => navigate('/perfil/endereco')}></ListItem>

        <ListItem
          text={'Pagamentos'}
          description={'Histórico de pagamentos'}
          leftIcon={'Pagamento'}
          onClick={() => navigate('/perfil/menu-pagamentos')}
        ></ListItem>

        <ListItem
          text={'Assinatura'}
          description={'Informações da minha assinatura'}
          leftIcon={'Assinaturas'}
          onClick={() => navigate('/perfil/assinaturas')}
        ></ListItem>

        <ListItem text={'Suporte'} description={'Falar com o suporte'} leftIcon={''} onClick={() => disclousureSuporte.onOpen()}></ListItem>
        <ListItem text={'Senha'} description={'Redefinir senha'} leftIcon={'Senha'} onClick={() => navigate('/recuperacao/trocarsenha')}></ListItem>
      </VStack>

      <Box p={8}>
        <Button isFullWidth bg={theme.background} color={theme.fontcolor} onClick={() => setSair(true)}>
          Sair
        </Button>
      </Box>

      <WrapItem mt="75">
        <BottomNavBar name="perfil" />
      </WrapItem>
    </>
  );
}

export default Main;
